
import { Component, Prop } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import InputFieldMixin from '~/components/Inputs/InputFieldMixin';

@Component
export default class TextInput extends mixins(InputFieldMixin) {
  @Prop({ default: () => [] }) rules!: Array<() => boolean | string>;

  defaultDataTestAttr = 'text';

  get mergedRules() {
    return [this.isRequired, ...this.rules];
  }
}
